export default [    //巡更管理
  {//巡更主页
    path: "/patrol",
    name: 'patrol',
    component: () => import("@/views/patrol/patrol.vue")
  },

  {//巡更计划
    path: "/patrolPlan",
    name: 'patrolPlan',
    component: () => import("@/views/patrol/patrolPlan.vue")
  },

  {//新增巡更计划
    path: "/addPatrolPlan",
    name:"addPatrolPlan",
    meta: {
      keepAlive: true // 需要缓存
    },
    component: ()=> import("@/views/patrol/addPatrolPlan.vue")
  },

  {//编辑巡更计划
    path: "/editPatrolPlan",
    name:"editPatrolPlan",
    meta: {
      keepAlive: true // 需要缓存
    },
    component: ()=> import("@/views/patrol/editPatrolPlan.vue")
  },

  {//巡更计划详情
    path: "/patrolPlanDetail",
    name:"patrolPlanDetail",
    component: ()=> import("@/views/patrol/patrolPlanDetail.vue")
  },

  {//巡更用户列表
    path: "/patrolUsers",
    name:"patrolUsers",
    meta: {
      keepAlive: true // 需要缓存
    },
    component: ()=> import("@/views/patrol/patrolUsers.vue")
  },

  {//添加巡更用户列表
    path: "/addPatrolUsers",
    name:"addPatrolUsers",
    component: ()=> import("@/views/patrol/addPatrolUsers.vue")
  },

  {//巡更点列表
    path: "/patrolPointList",
    name:"patrolPointList",
    meta: {
      keepAlive: true // 需要缓存
    },
    component: ()=> import("@/views/patrol/patrolPointList.vue")
  },

  {//添加巡更点列表
    path: "/addPatrolPoints",
    name:"addPatrolPoints",
    component: ()=> import("@/views/patrol/addPatrolPoints.vue")
  },

  {//巡更报表
    path: "/patrolReport",
    name: 'patrolReport',
    component: () => import("@/views/patrol/patrolReport.vue")
  },

  {//执行任务
    path: '/performTsks',
    name: 'performTsks',
    component: ()=> import("@/views/patrol/performTsks.vue")
  },

  {//执行任务详情
    path: "/performTsksDetails",
    name:"performTsksDetails",
    component: ()=> import("@/views/patrol/performTsksDetails.vue")
  },
]
